export enum FeatureFlagValue {
  On = "true",
  Off = "false",
}

// There are additional flags defined in CCS, but none of them are utilized in the FE code
export enum FeatureFlagName {
  ShowTranslateMenu = "FTE-5071-showTranslateMenu",
  EnableExternalUserCreation = "FTE-44823-enableExternalUser",
  EnableEditStructureDocumentSectionTitle = "FTE-54155-enableEditStructuredDocumentSections",
  EnableEmailGroupMilestones = "FTE-55113-enableMilestoneEmails",
  EnableNewInlineUIEnhancements = "FTE-52967-enableNewInLineUIEnhancements",
  EnableIntegrationSync = "FTE-55449-integration-sync",
  EnableProjectAccessUI = "FTE-57836-project-access-ui",
  EnableSimplifyContent = "FTE-59796-simplify-content",
  EnableContentTableUIImprovements = "FTE-59803-content-table-ui-improvements",
  EnableDocumentToTemplateAI = "FTE-60242-doc-to-template-ai",
  EnableResendInvitations = "FTE-60403-resend-invitations",
  EnableSimplifiedHAQsForHAs = "FTE-60052-simplified-questions-for-participating-org",
  EnableAssetServiceChangeDueDateEndpoint = "FTE-61452-migrate-change-due-date-workflow",
  EnableSimplifiedHAQsForSponsors = "FTE-60091-simplified-questions-for-initiating-org",
  EnableProjectStatusChangeEndpoint = "FTE-62258-migrate-project-status-change-workflow",
  EnableHAQSimplificationFastFollow = "FTE-62891-haq-simplification-fast-follow",
  EnableLargeDossierSupport = "FTE-62440-large-dossier-support",
  EnableRemoveProjectInvitationsPreferences = "FTE-62917-remove-project-invitations-preferences",
}
